import React from "react";
import { Modal, Form, Button, Alert } from "react-bootstrap";
const ModalFormRegisterOrUpdate = ({
  controlFormId,
  dataTypePlv,
  registerOrUpdate,
  name,
  lastname,
  email,
  qtyMax,
  customerPlv,
  phoneNbr,
  customerPlvManufacturing,
  customerPlvPassing,
  setCustomerPlvManufacturing,
  setCustomerPlvPassing,
  typePlvByDefault,
  setTypePlvByDefault,
  setCustomerPlv,
  setPhoneNbr,
  setName,
  setLastname,
  setEmail,
  setQuantityMax,
  show,
  handleClose,
  dataCustomerPlv,
  errorMessage,
}) => {
  const [formData] = React.useState({
    firstname_libelle: name || "",
    lastname: lastname || "",
    email: email || "",
    phone: phoneNbr || "",
    qtyMax: qtyMax || "",
    customerPlv: customerPlv || "",
    customerPlvManufacturing: customerPlvManufacturing || 0,
    customerPlvPassing: customerPlvPassing || 0,
    typePlvByDefault: typePlvByDefault || 0,
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });

  /**
   * Cette fonction gère le changement de valeur des champs de saisie.
   * Elle prend en compte le nom du champ modifié (e.target.name) pour effectuer des actions spécifiques en fonction du champ.
   * Si le champ est "qtyMax" ou "customerPlv", elle met à jour les nouvelles données de formulaire en convertissant la valeur en nombre entier (si possible) ou en chaîne vide.
   * Si le champ est "typePlvByDefault", "customerPlvPassing" ou "customerPlvManufacturing", elle met à jour les nouvelles données de formulaire en convertissant la valeur en nombre entier (0 si la valeur est 1, sinon 1).
   * Pour tous les autres champs, elle met simplement à jour les nouvelles données de formulaire avec la valeur saisie.
   */
  const handleInputChange = (e) => {
    if (e.target.name === "qtyMax" || e.target.name === "customerPlv") {
      setNewFormData({
        ...newFormData,
        [e.target.name]: !isNaN(parseInt(e.target.value))
          ? parseInt(e.target.value)
          : "",
      });
    } else if (
      e.target.name === "typePlvByDefault" ||
      e.target.name === "customerPlvPassing" ||
      e.target.name === "customerPlvManufacturing"
    ) {
      setNewFormData({
        ...newFormData,
        [e.target.name]: parseInt(e.target.value) === 1 ? 0 : 1,
      });
    } else {
      setNewFormData({ ...newFormData, [e.target.name]: e.target.value });
    }
  };

  /**
   * Cette fonction gère la fermeture de la modal.
   * Elle vérifie s'il y a eu des changements dans les données du formulaire en comparant formData et newFormData.
   * Si des changements ont été effectués, elle affiche une fenêtre de confirmation pour demander à l'utilisateur s'il souhaite quitter sans valider les changements.
   * Si l'utilisateur confirme, la modal est fermée. Sinon, rien ne se passe.
   * Si aucun changement n'a été effectué, la modal est fermée directement.
   */
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };

  /**
   * Cette fonction retourne le nom de la page à partir de l'identifiant du composant appelant.
   * Elle vérifie l'identifiant du composant (controlFormId) pour déterminer quelle page est appelée.
   * Si l'identifiant contient "ambassadrice", le nom de la page retourné est "Ambassadrice".
   * Si l'identifiant contient "communication", le nom de la page retourné est "Outil de communication".
   * Si l'identifiant contient "types-plv", le nom de la page retourné est "Type de PLV".
   * Si l'identifiant contient "customer-plvs", le nom de la page retourné est "PLV".
   * Si l'identifiant contient "kam", le nom de la page retourné est "KAM".
   * Le nom de la page est ensuite retourné.
   */
  const getNamePageCallingComponent = () => {
    var namePage = "";
    if (controlFormId.includes("ambassadrice")) {
      namePage = "Ambassadrice";
    } else if (controlFormId.includes("communication")) {
      namePage = "Outil de communication";
    } else if (controlFormId.includes("types-plv")) {
      namePage = "Type de PLV";
    } else if (controlFormId.includes("customer-plvs")) {
      namePage = "PLV";
    } else if (controlFormId.includes("kam")) {
      namePage = "KAM";
    }
    return namePage;
  };

  const [dataTypePlvNotUsed, setDataTypePlvNotUsed] = React.useState([]);

  React.useEffect(() => {
    var tab = [];
    if (dataTypePlv && dataCustomerPlv) {
      // pour afficher uniquement les plvs non sélectionné dans un client sur la page Merchandising
      tab = dataTypePlv.filter((eltType) => {
        return !dataCustomerPlv.some(
          (eltCustomer) => eltCustomer.operation_plv_type_id === eltType.id
        );
      });
      setDataTypePlvNotUsed(tab);
    }
  }, []);
  return (
    <Modal size="lg" show={show} onHide={() => handleModalHide()} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {controlFormId.includes("update")
            ? `Modifier ${getNamePageCallingComponent()}`
            : `Ajouter ${getNamePageCallingComponent()}`}
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          registerOrUpdate(e);
        }}
      >
        <Modal.Body>
          <div className="row">
            {controlFormId.includes("ambassadrice") ||
            controlFormId.includes("kam") ? (
              <>
                <div className="col-md-6">
                  <Form.Group
                    className="mb-3"
                    controlId={`new-name-${controlFormId}`}
                  >
                    <Form.Label>Nom</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Nom"
                      autoFocus
                      required
                      name="nom"
                      value={lastname}
                      onChange={(e) => {
                        handleInputChange(e);
                        setLastname(e.target.value);
                      }}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId={`new-email-${controlFormId}}`}
                  >
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Email"
                      //pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                      autoComplete={`new-email-${controlFormId}`}
                      title="ex : utilisateur@gmail.com"
                      required
                      value={email}
                      name="email"
                      onChange={(e) => {
                        handleInputChange(e);
                        setEmail(e.target.value);
                      }}
                    />
                  </Form.Group>
                </div>
                {errorMessage && (
                  <div className="col-md-12 mb-3 p-1">
                    <Alert variant="danger" className="m-0">
                      {errorMessage}
                    </Alert>
                  </div>
                )}
              </>
            ) : (
              ""
            )}

            <div
              className={`${
                controlFormId.includes("ambassadrice") ||
                controlFormId.includes("kam")
                  ? "col-md-6"
                  : "col-md-12"
              }`}
            >
              {controlFormId.includes("customer-plvs") ? (
                <>
                  {!controlFormId.includes("update-customer-plvs") && (
                    <Form.Group
                      className="mb-3"
                      controlId={`select-${controlFormId}`}
                    >
                      <Form.Label>Choisir le PLV</Form.Label>
                      <Form.Select
                        required
                        value={customerPlv}
                        name="customerPlv"
                        onChange={(e) => {
                          handleInputChange(e);
                          setCustomerPlv(e.target.value);
                        }}
                      >
                        <option value="">Sélectionnez un type de plv</option>
                        {dataTypePlvNotUsed.map((elt) => (
                          <option value={elt.id} key={elt.id}>
                            {elt.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  )}
                  <Form.Group
                    className="mb-3"
                    controlId={`quantity-${controlFormId}`}
                  >
                    <Form.Label>Définir quantité max</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      required
                      placeholder="Quantité max"
                      value={qtyMax}
                      name="qtyMax"
                      onChange={(e) => {
                        handleInputChange(e);
                        setQuantityMax(e.target.value);
                      }}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId={`switch-manufacturing-${controlFormId}`}
                  >
                    <Form.Label>Fabrication PLV</Form.Label>
                    <Form.Check
                      type="switch"
                      checked={customerPlvManufacturing === 1 ? true : false}
                      label={customerPlvManufacturing === 1 ? "Oui" : "Non"}
                      required
                      value={customerPlvManufacturing}
                      readOnly
                      name="customerPlvManufacturing"
                      onClick={(e) => {
                        handleInputChange(e);
                        setCustomerPlvManufacturing(
                          customerPlvManufacturing === 1 ? 0 : 1
                        );
                      }}
                    />
                  </Form.Group>
                  <Form.Group
                    className="mb-3"
                    controlId={`switch-passing-${controlFormId}`}
                  >
                    <Form.Label>Passage prestataire</Form.Label>
                    <Form.Check
                      type="switch"
                      checked={customerPlvPassing === 1 ? true : false}
                      label={customerPlvPassing === 1 ? "Oui" : "Non"}
                      required
                      value={customerPlvPassing}
                      readOnly
                      name="customerPlvPassing"
                      onClick={(e) => {
                        handleInputChange(e);
                        setCustomerPlvPassing(customerPlvPassing === 1 ? 0 : 1);
                      }}
                    />
                  </Form.Group>
                </>
              ) : (
                <>
                  <Form.Group
                    className="mb-3"
                    controlId={`new-name-${controlFormId}`}
                  >
                    <Form.Label>
                      {controlFormId.includes("ambassadrice") ||
                      controlFormId.includes("kam")
                        ? "Prénom"
                        : "Libellé"}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={`${
                        controlFormId.includes("ambassadrice") ||
                        controlFormId.includes("kam")
                          ? "Prénom"
                          : `Libellé ${getNamePageCallingComponent()}`
                      }`}
                      maxLength={
                        controlFormId.includes("communication-comtool") ||
                        controlFormId.includes("types-plv")
                          ? "16"
                          : ""
                      }
                      required
                      value={name}
                      name="firstname_libelle"
                      onChange={(e) => {
                        handleInputChange(e);
                        setName(e.target.value);
                      }}
                    />
                  </Form.Group>
                  {errorMessage && (
                    <div className="col-md-12 mb-3 p-1">
                      <Alert variant="danger" className="m-0">
                        {errorMessage}
                      </Alert>
                    </div>
                  )}
                  {controlFormId.includes("kam") && (
                    <Form.Group
                      className="mb-3"
                      controlId={`new-phone-${controlFormId}`}
                    >
                      <Form.Label>Numéro de téléphone</Form.Label>
                      <Form.Control
                        type="tel"
                        //pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                        placeholder={`${"06XXXXXXXX"}`}
                        required
                        value={phoneNbr}
                        name="phone"
                        onChange={(e) => {
                          handleInputChange(e);
                          setPhoneNbr(e.target.value);
                        }}
                      />
                    </Form.Group>
                  )}
                  {controlFormId.includes("types-plv") && (
                    <Form.Group
                      className="mb-3"
                      controlId={`switch-bydefault-${controlFormId}`}
                    >
                      <Form.Label>Ajouter par défault aux clients</Form.Label>
                      <Form.Check
                        type="switch"
                        checked={typePlvByDefault === 1 ? true : false}
                        label={typePlvByDefault === 1 ? "Oui" : "Non"}
                        required
                        value={typePlvByDefault}
                        readOnly
                        name="typePlvByDefault"
                        onClick={(e) => {
                          handleInputChange(e);
                          setTypePlvByDefault(typePlvByDefault === 1 ? 0 : 1);
                        }}
                      />
                    </Form.Group>
                  )}
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            className="button grey-dark-button"
            onClick={() => handleClose()}
          >
            Annuler
          </Button>
          <Button type="submit" className="button green-button">
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalFormRegisterOrUpdate;
